import React from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from 'recharts';

export function SentVsSubmittedChart({ data }) {
  const hasData = Array.isArray(data) && data.some(d => d.sent > 0 || d.submitted > 0);
  if (!hasData) {
    return <div className="text-sm text-slate-400 py-8 text-center">Noch keine versendeten Links im Zeitraum.</div>;
  }
  return (
    <ResponsiveContainer width="100%" height={260}>
      <LineChart data={data} margin={{ top: 8, right: 8, bottom: 8, left: -16 }}>
        <XAxis dataKey="label" tick={{ fontSize: 11 }} />
        <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
        <Tooltip />
        <Legend />
        <Line type="monotone" dataKey="sent" name="Fragebögen" stroke="#0891b2" strokeWidth={2} dot={false} />
        <Line type="monotone" dataKey="submitted" name="Ergebnisse" stroke="#15803d" strokeWidth={2} dot={false} />
      </LineChart>
    </ResponsiveContainer>
  );
}
